<template>
  <div class="campus-carousel">
    <div class="tabs">
      <div @click="choType(19)" :class="cType == 19 ? 'active' : ''">
        校园风光
        <div v-if="cType == 19" class="ll"></div>
      </div>
      <div @click="choType(20)" :class="cType == 20 ? 'active' : ''">
        毕业证
        <div v-if="cType == 20" class="ll"></div>
      </div>
      <div @click="choType(21)" :class="cType == 21 ? 'active' : ''">
        学员风采
        <div v-if="cType == 21" class="ll"></div>
      </div>
    </div>
    <div v-if="images.length >= 3" class="swiper-container">
      <swiper ref="mySwiper" :options="swiperOptions" @slideChange="handleSlideChange">
        <swiper-slide v-for="(item, index) in images" :key="index" :class="{ active: isActive(index) }">
          <img :src="item.img" />
          <p class="title elp">{{ item.name }}</p>
        </swiper-slide>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import { getSurfaceList } from "@/api/home";
import { getInfo } from "@/api/cookies";
import { getDomain } from "@/api/cookies";
import { queryAllArticle } from "@/api/home";

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      imgList: [],
      domain: null,
      imgUrl: "",
      userSource: "PC端",
      userInfo: null,
      newsList: [],
      currentIndex: 2,
      i19: false,
      i20: false,
      i21: false,
      cType: 19,
      swiperInstance: null,
      images: [],
      swiperOptions: {
        slidesPerView: 5,
        centeredSlides: true,
        spaceBetween: 10,
        loop: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        loopAdditionalSlides: 2,
        initialSlide: 2, // 默认显示中间的幻灯片
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        on: {
          init: this.handleSwiperInit,
          slideChange: this.handleSlideChange,
          afterInit: this.centerActiveSlide, // 新增初始化后居中活动幻灯片
        },
      },
    };
  },
  async created() {
    this.domain = getDomain();
    this.userInfo = await getInfo();
    getSurfaceList(19, undefined, this.domain.entrantsType).then((res) => {
      if (res.msg && res.msg.length > 4) {
        this.i19 = true
        this.images = JSON.parse(JSON.stringify(res.msg));
        this.$nextTick(() => {
          if (this.$refs.mySwiper) {
            this.swiperInstance = this.$refs.mySwiper.$swiper;
            // 确保默认选中中间的幻灯片
            this.centerActiveSlide();
          }
        });
      }
    });

  },
  methods: {
    choType(i) {
      this.cType = i;
      getSurfaceList(i, undefined, this.domain.entrantsType).then((res) => {
        if (res.code == 0) {
          this.images = JSON.parse(JSON.stringify(res.msg));
          this.$nextTick(() => {
            if (this.$refs.mySwiper) {
              this.swiperInstance = this.$refs.mySwiper.$swiper;
              // 切换类型后重新居中
              this.centerActiveSlide();
              if (this.swiperInstance.autoplay) {
                this.swiperInstance.autoplay.start();
              }
            }
          });
        }
      });
    },

    // 新增方法：居中活动幻灯片
    centerActiveSlide() {
      if (!this.swiperInstance || !this.images.length) return;

      // 计算中间索引
      const middleIndex = Math.floor(this.images.length / 2);
      this.swiperInstance.slideTo(middleIndex);
    },

    handleSwiperInit() {
      this.$nextTick(() => {
        if (this.swiperInstance) {
          this.updateActiveSlide();
          if (this.swiperInstance.autoplay) {
            this.swiperInstance.autoplay.start();
          }
        }
      });
    },
    handleSlideChange() {
      this.$nextTick(() => {
        this.updateActiveSlide();
      });
    },

    isActive(index) {
      if (!this.swiperInstance) return false;
      const realIndex = this.swiperInstance.realIndex || 0;
      const slidesPerView = this.swiperOptions.slidesPerView;
      const centerIndex = Math.floor(slidesPerView / 2);
      return (index - realIndex) % this.images.length === centerIndex;
    },
    updateActiveSlide() {
      if (!this.swiperInstance || !this.swiperInstance.slides) return;

      // 移除所有相关类
      Array.from(this.swiperInstance.slides).forEach((slide) => {
        if (slide && slide.classList) {
          slide.classList.remove("active");
          slide.classList.remove("side-slide");
        }
      });

      // 添加 active 类
      const activeSlide = this.swiperInstance.slides[this.swiperInstance.activeIndex];
      if (activeSlide && activeSlide.classList) {
        activeSlide.classList.add("active");
      }

      // 计算左右两侧第一个幻灯片索引
      const slidesCount = this.swiperInstance.slides.length;
      const leftIndex = (this.swiperInstance.activeIndex - 2 + slidesCount) % slidesCount;
      const rightIndex = (this.swiperInstance.activeIndex + 2) % slidesCount;

      // 给左右两侧第一个幻灯片添加 side-slide 类
      const leftSlide = this.swiperInstance.slides[leftIndex];
      const rightSlide = this.swiperInstance.slides[rightIndex];
      if (leftSlide && leftSlide.classList) {
        leftSlide.classList.add("side-slide");
      }
      if (rightSlide && rightSlide.classList) {
        rightSlide.classList.add("side-slide");
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs.mySwiper) {
        this.swiperInstance = this.$refs.mySwiper.$swiper;
      }
    });
  },
};
</script>

<style lang="less" scoped>
/* 保持原有样式不变 */
.campus-carousel {
  min-height: 538px;
  padding: 77px 0;
  padding-bottom: 50px;
  background: url("https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x30.png");
  background-size: 100% 100%;

  .tabs {
    width: 1200px;
    margin: 0 auto;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    font-size: 20px;
    color: #ffffff;
    margin-bottom: 20px;
    display: flex;
    align-items: center;

    div {
      position: relative;
      margin-right: 48px;
      cursor: pointer;

      &.active {
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: bold;
        font-size: 24px;
        color: #ffffff;
      }

      .ll {
        position: absolute;
        width: 28px;
        height: 4px;
        background: #ffffff;
        border-radius: 2px 2px 2px 2px;
        bottom: -5px;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }

  .swiper-container {
    position: relative;

    //  overflow: visible;
    .swiper-slide {
      transition: all 0.3s ease;
      // opacity: 0.5;
      transform: scale(0.9);
      border-radius: 6px;
      overflow-x: hidden;
      box-sizing: border-box;
      top: 20px;

      img {
        max-width: 100%;
        height: 257px;
        width: 100%;
        object-fit: cover;
        border-radius: 6px;
      }

      .title {
        text-align: center;
        font-weight: 400;
        margin-top: 20px;
        color: white;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-size: 16px;
      }

      &.active {
        width: 413px !important;
        opacity: 1;
        transform: scale(1);
        z-index: 10;
        background: #ffffff;
        border-radius: 8px 8px 8px 8px;
        padding: 20px;
        top: 0;

        .title {
          font-family: Microsoft YaHei, Microsoft YaHei;
          font-weight: bold;
          font-size: 16px;
          color: #333333;
        }
      }

      // &:nth-child(1) {
      //   margin-left: -60px;
      //   /* 根据需要调整负值大小 */
      //   opacity: 0.3;
      //   transform: scale(0.9);
      //   z-index: 1;
      // }

      // /* 右侧第一个幻灯片 */
      // &:nth-child(5) {
      //   margin-right: -60px;
      //   /* 根据需要调整负值大小 */
      //   opacity: 0.3;
      //   transform: scale(0.9);
      //   z-index: 1;
      // }
    }

    .swiper-button-prev,
    .swiper-button-next {
      width: 48px;
      height: 48px;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.7);

      &::after {
        font-size: 16px;
        color: #1e6dfd;
        content: "";
      }
    }

    .swiper-button-prev {
      left: 340px;
      right: auto;
      background-image: url("https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x31.png");
      background-size: 100% 100%;
    }

    .swiper-button-next {
      right: 340px;
      left: auto;
      background-image: url("https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x32.png");
      background-size: 100% 100%;
    }

  }
}

.swiper-slide.side-slide {
  opacity: 0.5 !important;
  // transform: scale(0.9) !important;
  z-index: 1 !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
}
</style>
